import React from "react";
import EntityManagement from "../../components/EntityManagement/EntityManagement";

const Vendors = () => (
  <EntityManagement
    title="Vendors"
    roleFilter="BUYER"
    showWallet
    subtitle="Buy-side vendors only. Wallet balance and holds are shown for assignment checks."
  />
);

export default Vendors;
